import { Component } from '@angular/core';

@Component({
  selector: 'app-topbar-notification-dropdown',
  imports: [],
  templateUrl: './topbar-notification-dropdown.component.html',
  styleUrl: './topbar-notification-dropdown.component.scss'
})
export class TopbarNotificationDropdownComponent {

}
